import type { TabConfig } from "@/components/shared/UniversalDetailPage/types/tab-types";
import type { Deal } from "@/lib/types/database/deals";

export const dealDetailTabs: TabConfig<Deal>[] = [
  // ========================================================================
  // CORE INFORMATION GROUP
  // ========================================================================
  {
    id: "details",
    label: "Details",
    icon: "FileText",
    variant: "blue",
    content: {
      type: "custom",
      customComponent: "DealDetailsTab",
    },
    group: "core",
    priority: 1,
  },
  {
    id: "company",
    label: "Company",
    icon: "Building",
    variant: "blue",
    content: {
      type: "custom",
      customComponent: "DealCompanyTab",
    },
    group: "core",
    priority: 2,
  },
  {
    id: "contacts",
    label: "Contacts",
    icon: "Users",
    variant: "blue",
    content: {
      type: "custom",
      customComponent: "DealContactsTab",
    },
    group: "core",
    priority: 3,
  },
  {
    id: "health",
    label: "Project Health",
    icon: "Activity",
    variant: "green",
    content: {
      type: "custom",
      customComponent: "DealProjectHealthTab",
    },
    group: "core",
    priority: 4,
  },
  {
    id: "project-channel",
    label: "Project Chat",
    icon: "MessageSquare",
    variant: "blue",
    content: {
      type: "custom",
      customComponent: "DealProjectChannelDisplay",
    },
    group: "core",
    priority: 5,
  },

  // ========================================================================
  // ACTIVITY GROUP
  // ========================================================================
  {
    id: "tasks",
    label: "Tasks",
    icon: "CheckSquare",
    variant: "green",
    content: {
      type: "custom",
      customComponent: "DealTasksDisplay",
    },
    group: "activity",
    priority: 1,
  },
  {
    id: "communications",
    label: "Communications",
    icon: "Mail",
    variant: "purple",
    content: {
      type: "custom",
      customComponent: "DealCommunicationsDisplay",
    },
    group: "activity",
    priority: 1.5,
    visible: (deal) => typeof deal.company_id === "string" && deal.company_id.length > 0,
  },
  {
    id: "quickbooks",
    label: "QuickBooks",
    icon: "Landmark",
    variant: "green",
    content: {
      type: "custom",
      customComponent: "DealQuickBooksDisplay",
    },
    group: "integration",
    priority: 1,
    visible: (deal) => typeof deal.company_id === "string" && deal.company_id.length > 0,
  },
  {
    id: "contracts",
    label: "Contracts",
    icon: "FileSignature",
    variant: "blue",
    content: {
      type: "custom",
      customComponent: "DealContractsDisplay",
    },
    group: "activity",
    priority: 1.75,
  },
  {
    id: "timeline",
    label: "Timeline",
    icon: "Clock",
    variant: "purple",
    content: {
      type: "custom",
      customComponent: "DealTimelineDisplay",
    },
    group: "activity",
    priority: 2,
  },
];
